<div class="form-group row" [formGroupName]='groupName'>
  <label class="col-sm-3 col-form-label" *ngIf="label"><span>{{ label }}<span *ngIf="required" class="required">*</span></span></label>
  <div [ngClass]="label ? 'col-sm-9' : 'col-12'">
    <input
      nbInput
      fullWidth
      shape="rectangle"
      [type]="type"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [status]="(control.invalid && control.touched) ? 'danger' : 'basic'"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      autocomplete="null"
    />
    <span [ngxAppValidationMessageFor]="control" class="error-message">
    </span>
  </div>
</div>
